<template>
  <v-layout column>
    <v-flex xs12>
      <h1>Акции</h1>
    </v-flex>
    <v-flex xs12 v-if="isAdministrator">
      <v-layout column>
        <v-flex xs12>
          <v-card class="elevation-3 pa-2">
            <v-btn color="primary" @click.stop="addPromotion">
              <v-icon>{{ icons.plus }}</v-icon
              >&nbsp;Добавить акцию
            </v-btn>
          </v-card>
        </v-flex>
        <v-flex xs12 class="my-2">
          <Promotions
            :promotions="promotions"
            v-on:edit-promotion="onEditPromotion"
            v-on:delete-promotion="onDeletePromotion"
          />
        </v-flex>
        <v-dialog persistent v-model="dialogPromotion" max-width="500px">
          <Promotion
            :organizations="organizations"
            :promotion="this.promotion"
            v-on:cancel-promotion="onCancelPromotion"
            v-on:save-promotion="onSavePromotion"
          />
        </v-dialog>
      </v-layout>
    </v-flex>
    <v-flex xs12 v-else>
      <v-layout row>
        <v-flex xs12 md6>
          <CalendarPromotions :calendar="calendarModel" />
        </v-flex>
        <v-flex xs12 md6>
          <ValidPromotions :promotions="validPromotions" />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { Icon } from "@/helpers";

const Promotions = () => import("@/components/Promotions/Promotions");
const Promotion = () => import("@/components/Promotions/Promotion");
const ValidPromotions = () => import("@/components/Promotions/ValidPromotions");
const CalendarPromotions = () =>
  import("@/components/Promotions/CalendarPromotions");

export default {
  components: {
    Promotions,
    Promotion,
    ValidPromotions,
    CalendarPromotions,
  },
  computed: {
    ...mapState({
      user: (state) => state.users.user,
      promotions: (state) => state.promotions.promotions,
      validPromotions: (state) => state.promotions.validPromotions,
      organizations: (state) => state.organizations.organizations,
    }),
    isAdministrator: function () {
      return this.user.userRoles != null
        ? this.user.userRoles.includes("Administrator")
        : null;
    },
    calendarModel: function () {
      return [
        {
          calendarId: "0000-0000",
          link: "/promotionfiles/calendar.xlsx",
          name: "Календарь рекламы",
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      getUser: "users/GET_USER",
      getPromotions: "promotions/GET_PROMOTIONS",
      createPromotion: "promotions/ADD_PROMOTION",
      updatePromotion: "promotions/UPDATE_PROMOTION",
      deletePromotion: "promotions/REMOVE_PROMOTION",
      getValidPromotions: "promotions/GET_VALID_PROMOTIONS",
      getOrganizations: "organizations/GET_ORGANIZATIONS",
    }),
    addPromotion: function () {
      this.promotion = new Object();
      this.dialogPromotion = true;
    },
    onCancelPromotion: function () {
      this.dialogPromotion = false;
    },
    onSavePromotion: async function (promotion) {
      if (promotion && promotion != null) {
        if (promotion.promotionId && promotion.promotionId != null) {
          await this.updatePromotion(promotion);
        } else {
          await this.createPromotion(promotion);
        }
        await this.getPromotions();
      }
      this.dialogPromotion = false;
    },
    onEditPromotion: async function (promotion) {
      this.promotion = promotion;
      this.dialogPromotion = true;
    },
    onDeletePromotion: async function (promotion) {
      await this.deletePromotion(promotion);
      await this.getPromotions();
    },
  },
  data: () => ({
    dialogPromotion: false,
    promotion: {},
    icons: {
      plus: Icon.plus,
    },
  }),
  mounted: async function () {
    await this.getUser(this.user.userId);

    if (this.isAdministrator) {
      await this.getPromotions();
      await this.getOrganizations();
    } else await this.getValidPromotions(this.user.userId);
  },
};
</script>
